export default {
  year: 2017,
  edition: "제 13회",
  date: "2017년 11월 20일 월요일",
  time: "오후 7시 ~ 10시",
  location: "다산관 D104",
  links: {
    problems: {
      BOJ: "https://www.acmicpc.net/category/detail/1809",
    },
  },
  authors: ["박건", "이준석", "최윤영", "고성빈", "정성엽", "하태훈"],
  contests: [
    {
      title: "SPC 2017 Master",
      columns: ["#", "=", "이름"],
      data: [
        ["1", "5", "정기웅"],
        ["2", "5", "이용욱"],
        ["3", "4", "전민수"],
        ["4", "3", "송인아"],
        ["5", "3", "김인호"],
        ["6", "3", "이동승"],
      ],
      award: ["gold", "silver", "silver", "bronze", "bronze", "bronze"],
      links: [["스코어보드", "https://www.acmicpc.net/contest/board/265"]],
    },
    {
      title: "SPC 2017 Champion",
      columns: ["#", "=", "이름"],
      data: [
        ["1", "3", "손정연"],
        ["2", "3", "윤기영"],
        ["3", "3", "엄태경"],
        ["4", "3", "임창현"],
        ["5", "2", "안성진"],
        ["6", "1", "권명준"],
        ["7", "1", "이수경"],
      ],
      award: [
        "winner",
        "gold",
        "silver",
        "silver",
        "bronze",
        "bronze",
        "bronze",
      ],
      links: [["스코어보드", "https://www.acmicpc.net/contest/board/266"]],
    },
  ],
};
